import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CheckInterface } from 'src/app/interfaces/check.interface';
import { environment } from 'src/environments/environment';
import { runtimeEnvironment } from 'src/environments/runtimeEnvironment';
import { SessionService } from '../session/session.service';

@Injectable({
  providedIn: 'root'
})
export class CheckService {

  private checkUrl: string;
  private token: string;

  constructor(public _http: HttpClient, private _session: SessionService) {
    this.checkUrl = runtimeEnvironment.test ? runtimeEnvironment.test + '/datamaster/businessModels' : `${environment.apiUrl}/datamaster/businessModels`;
    this._session.getTokenSubj$().subscribe((usertoken: string) => {
      if (usertoken) {
        this.token = usertoken;
      }
    });
  }

  public getAllChecks(idBusinessLine: number, filterText: string): Observable<CheckInterface[]> {
    const reqHeader = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
    let observable: Observable<CheckInterface[]>;
    if (filterText != undefined && filterText != '' && filterText != null) {
      let filter: string = filterText.toString().trim().toLowerCase();
      observable = this._http.get<CheckInterface[]>(`${this.checkUrl}/${idBusinessLine}/typechecks?name=${filter}`, { headers: reqHeader });
    } else {
      observable = this._http.get<CheckInterface[]>(`${this.checkUrl}/${idBusinessLine}/typechecks`, { headers: reqHeader });
    }
    return observable;
  }
}
